<template>
    <!-- for rerender toolbar after path change -->
    <v-toolbar>
        <v-toolbar-title>
            <v-breadcrumbs :items="currentRoute.matched" divider="/" :key="Math.random()">
                <template v-slot:item="{ item }">
                    <v-breadcrumbs-item :disabled="item.regex.test(currentRoute.path)" @click="goTo(item)" style="cursor: pointer">
                        <T>{{ item.meta.title }}</T>
                    </v-breadcrumbs-item>
                </template>
            </v-breadcrumbs>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <slot />
    </v-toolbar>
</template>

<script>
export default{
    computed:{
        currentRoute(){
            return this.$route
        },
    },
    methods:{
        goTo(item){
           this.$router.push({path: item.path})
        }
    },
}
</script>

   